module.exports = __webpack_public_path__ + "media/images/white-down-arrow-9edfd30de83ab849241079e16ac036c4.png";